/**
 * @author atul.silori <atul.silori@314ecorp.com>
 * @description ViewEligibilityRequestCheck
 */
import { Button as AntButton, ButtonProps } from 'antd';
import { Link } from 'react-router-dom';
import { useAppStoreValues } from 'store/app';
import { getNewEligibilityRequestPath, getPatientEligibilityNewRequestPath } from 'utils/router';

export interface IProps extends ButtonProps {
	isEligibilityPayer?: boolean;
	claimStatusRequestId?: string;
	patientId?: string;
}

/**
 * ViewEligibilityRequestChecks
 *
 */
const ViewEligibilityRequestChecks: React.FC<IProps> = (props) => {
	const { onClick, ...restProps } = props;
	const isEligibilityPayer = props?.isEligibilityPayer;
	const claimStatusRequestId = props?.claimStatusRequestId;
	const patientId = props?.patientId;
	const { setupInfo } = useAppStoreValues();
	const isBillingCustomer = setupInfo?.isBillingCustomer;

	const ButtonComponent = (
		<AntButton key='view-claim-status-response' onClick={onClick} {...restProps}>
			{'Check Eligibility'}
		</AntButton>
	);

	if (isBillingCustomer && patientId) {
		return <Link to={getPatientEligibilityNewRequestPath(patientId)}>{ButtonComponent}</Link>;
	} else if (isEligibilityPayer && claimStatusRequestId) {
		return <Link to={getNewEligibilityRequestPath({ claimStatusRequestId })}>{ButtonComponent}</Link>;
	}
	return null;
};

export default ViewEligibilityRequestChecks;
